import React from "react";
import RefreshIcon from "@mui/icons-material/Refresh";
import useNewAppVersionAvailable from "../../hooks/useNewAppVersionAvailable";
import { DesignDialog, DesignDialogButton } from "./dashboard/DesignDialog";

export const newVersionBannerMessage =
  "A new version of Chamber Member Pro is available. Reload to update.";

const reloadPage = () => window.location.reload();
const keepOpen = () => undefined;

/**
 * Tells a long-open tab that a new release is published. It is a standard
 * centred pop-up with only a Reload button (Moeen, Oct 11 2026): no close
 * button, and Escape or a backdrop click does not dismiss it. It never
 * reloads by itself. Reload goes through the browser's normal page unload,
 * so a form with unsaved changes still shows its leave warning.
 */
const NewVersionBanner = ({
  onReload = reloadPage,
}: {
  onReload?: () => void;
}) => {
  const newVersionAvailable = useNewAppVersionAvailable();

  return (
    <DesignDialog
      open={newVersionAvailable}
      onClose={keepOpen}
      title="New Version Available"
      message={newVersionBannerMessage}
      iconNode={<RefreshIcon />}
      iconColor="#E1A731"
      disableBackdropClose
      hideCloseButton
      actions={
        <DesignDialogButton onClick={onReload}>Reload</DesignDialogButton>
      }
    />
  );
};

export default NewVersionBanner;
